import { call, select } from 'redux-saga/effects';
import { getEnv } from 'common/store/selectors/env';
import { getRequestWhitelistCookiesString } from 'common/store/selectors/cookies';
import { api, ApiRequestConfig } from '../api';

const apiPaths = {
  getModel: 'getModel',
  getId: 'getId',
};

export function* post<Response = {}, Data extends {} = {}>(
  path: string,
  data: Data,
  config?: ApiRequestConfig
): Generator {
  return yield doRequest<Response, Data>('post', path, data, config);
}

export function* get<Response = unknown, Data extends {} = {}>(
  path: string,
  data: Data,
  config?: ApiRequestConfig
): Generator {
  return yield doRequest<Response, Data>('get', path, data, config);
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function* doRequest<Response, Data extends {}>(
  method: 'get' | 'post',
  path: string,
  data: Data,
  config: ApiRequestConfig = {}
): Generator {
  const { ORCHESTRATOR_HOST, SELF_ORCHESTRATOR_HOST, requestID, apiKey } = (yield select(
    getEnv
  )) as ReturnType<typeof getEnv>;

  if (__IS_SERVER__) {
    const cookie: unknown = yield select(getRequestWhitelistCookiesString);
    config.headers = { ...config.headers, Cookie: cookie };
  }

  if (requestID) {
    config.headers = { ...config.headers, 'x-request-id': requestID };
  }

  if (apiKey) {
    config.headers = { ...config.headers, 'x-api-key': apiKey };
  }

  const apiMethod = api[method];

  const mainHost = [apiPaths.getId, apiPaths.getModel].includes(path)
    ? SELF_ORCHESTRATOR_HOST
    : ORCHESTRATOR_HOST;

  return yield call(apiMethod, buildUrl(mainHost, path), data, config);
}

function buildUrl(base: string, part: string) {
  return new URL(part, base).toString();
}
